import { Box } from '@mui/material';

const email = {
  field: 'email',
  headerName: 'Email',
  flex: 1,
  minWidth: 110,
  type: 'customSelect',
  renderCell: (params) => (
    <Box component="div" sx={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}  >
      {params.value}
    </Box>
  ),
};

const type = {
  field: 'notificationTypeLabel',
  headerName: 'Send For',
  flex: 1,
  minWidth: 90,
  type: 'customSelect',
  renderCell: (params) => (
    <Box component="div"
      sx={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap', }}  >
      {params.value}
    </Box>
  ),
};
const recipientType = {
  field: 'recipientTypeLabel',
  headerName: 'Send Type',
  flex: 1,
  minWidth: 90,
  sortable: true,
  filterable: true,
  type: 'customSelect',
  renderCell: (params) => (
    <Box component="div"
      sx={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap', }}  >
      {params.value}
    </Box>
  ),
};
const site = {
  field: 'site',
  headerName: 'Site',
  path: 'site.label',
  flex: 1,
  minWidth: 90,
  type: 'customSelect',
  valueGetter: (params) => params.value?.label || '',
  renderCell: (params) => (<Box component="div" sx={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}  >
    {params.value}
  </Box>),
};


const EMAIL_RECIPIENTS = [email, site, type, recipientType];

export { EMAIL_RECIPIENTS };
